import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter,
  Switch,
} from "react-router-dom";
import firebase from "firebase";
import styled from "styled-components";

import { Navigation } from "./../lib/index";

import Explore from "./../Explore/Explore";
import ExploreSub from "./../Explore/ExploreSub";
import Information from "./../Information/Information";
import InformationSub from "./../Information/InformationSub";
import Concierge from "./../Concierge/Concierge";
import ConciergeSub from "./../Concierge/ConciergeSub";
import MapView from "./../MapView/MapView";
import News from "./../News/News";
import SignOut from "./../Auth/SignOut";
import Offer from "./../Offer/Offer";
import OfferSub from "./../Offer/OfferSub";
import LiveChat from "./../LiveChat/LiveChat";
import ChatView from "./../LiveChat/ChatView";
import User from "./../User/User";
import Order from "./../Order/Order";

const RootContainer = styled.div`
  display: flex;
  background-color: #f2c96d;
  height: 100%;
  flex-direction: column;
  padding: 20px;
`;

const Main = ({ match, location }) => {
  return (
    <RootContainer>
      <Navigation />
      <Switch>
        <Route path="/explore" component={Explore} />
        <Route path="/exploresub/:id" component={ExploreSub} />
        <Route path="/information" component={Information} />
        <Route path="/informationsub/:id" component={InformationSub} />
        <Route path="/concierge" component={Concierge} />
        <Route path="/conciergesub/:id" component={ConciergeSub} />
        <Route path="/order" component={Order} />
        <Route path="/map" component={MapView} />
        <Route path="/offer" component={Offer} />
        <Route path="/offersub/:id" component={OfferSub} />
        <Route path="/news" component={News} />
        <Route path="/livechat" component={LiveChat} />
        <Route
          path="/livechatid/:id"
          render={(props) => <ChatView {...props} />}
        />
        <Route path="/user" component={User} />
        <Route path="/signout" component={SignOut} />
        <Route path="/" render={() => <h3>Please select a topic.</h3>} />
      </Switch>
    </RootContainer>
  );
};

export default Main;
